<div class="page-layout blank p-24" fusePerfectScrollbar>

  <div class="main-widget">
    <div class="doc_title position-relative p-24 mat-blue-600-bg fx-row fx-justify-space-between fx-items-center">
      <div class="fx-column fx-justify-start fx-items-start">
        <span class="h2">{{'Documenti' | translate}}</span>
      </div>
    </div>
  </div>

  <div class="container-documents">

    <form #documentsForm="ngForm"> <!-- (ngSubmit)="download(documentsForm)" -->

      <!--Start Date-->
      <mat-form-field>
        <input matInput
          [matDatepicker]="picker"
          (click)='picker.open()'
          format="YYYY/MM/DD HH:mm:ss"
          [placeholder]='"Seleziona data" | translate'
          (dateInput)="addDate($event)"
          ngModel name="data"
          #dataValidation="ngModel"
          required />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker="matDatepicker"></mat-datepicker>
      </mat-form-field>

      @if (dataValidation.invalid && (dataValidation.dirty || dataValidation.touched)) {
        <div>
          @if (dataValidation.errors && dataValidation.errors.required) {
            <p class="data-documento" >* {{'Campo data obbligatorio' | translate}}</p>
          }
        </div>
      }
      <!--end start Date-->

      <!---RadioButton-->
      <mat-card class='p-24'>
        <mat-card-header>
          <mat-card-title>{{'Lista Partecipanti' | translate}}</mat-card-title>
        </mat-card-header>

        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" name="selectedRadio" [(ngModel)]="selectedRadio">
          @for (radio of radios; track radio) {
            <mat-radio-button class="example-radio-button" [value]="radio"
              [disabled]="dataValidation.invalid"
              (change)="radioListChange($event)">
              {{radio}}
            </mat-radio-button>
          }
        </mat-radio-group>

        <!--Package-->
        <div class="pacchetto-wrapper">
          @if (selectedRadio==='Pacchetto') {
            <mat-form-field class="filter-chip-list" >
              <mat-chip-grid #chipList aria-label="Package selection">
                @for (tripPackage of filterPackages; track tripPackage) {
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removePackage(tripPackage.id)">
                    {{ tripPackage.description }}
                    @if (true) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
                <input #filterInput
                  [placeholder]='"Seleziona pacchetto..." | translate'
                  (input)="loadPackages($event.target.value)"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipList"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addPackage($event)"
                  ngModel name="pacchetto"
                  [required]="selectedRadio==='Pacchetto'" />
              </mat-chip-grid>
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onSelectPackage($event)">
                @for (option of filteredOptions | async; track option) {
                  <mat-option
                    [value]="option">
                    {{ option.description }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        </div>
        <!--end Package-->

        @if (selectedPackage) {
          <div class="sottofiltri-pacchetto">
            <mat-checkbox
              [disabled]="!selectedPackage"
              [matTooltip]='"Filtra nel pacchetto selezionato" | translate'
              name="packageSubFilters"
              [(ngModel)]="packageSubFilters"
              (change)="packageSubFiltersEvent($event)">
              {{'ATTIVA SOTTOFILTRI PACCHETTO' | translate}}
            </mat-checkbox>
          </div>
        }

        @if (selectedRadio === 'Pacchetto' && packageSubFilters) {
          <mat-radio-group
            class="package-sub-filters"
            name="selectedSubPackFilter"
            [(ngModel)]="selectedSubPackFilter"
            >
            @for (radioP of subFilterPackages; track radioP) {
              <mat-radio-button [value]="radioP"
                [disabled]="dataValidation.invalid || !selectedPackage"
                (change)="radioSubPackListChange($event)">
                {{radioP}}
              </mat-radio-button>
            }
          </mat-radio-group>
        }

        <!-- ActualTrip -->
        <div class="div-wrapper">
          @if (selectedSubPackFilter==='Partenza') {
            <mat-form-field class="filter-chip-list">
              <mat-chip-grid #chipactList aria-label="ActualTrip selection">
                @for (tripActual of filterActual; track tripActual) {
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removeActual(tripActual.id)">
                    {{ tripActual.meeting_point_list_description }} - {{tripActual.start_time}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input #actualInput
                  [placeholder]='"Inserisci Partenza..." | translate'
                  (input)="actualFilteredOptions($event.target.value)"
                  [matAutocomplete]="autoact"
                  [matChipInputFor]="chipactList"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addActual($event)"
                  ngModel name="actualTrip" />
              </mat-chip-grid>
              <mat-autocomplete #autoact="matAutocomplete" (optionSelected)="onSelectActual($event)" >
                @for (option of actualOptions | async; track option) {
                  <mat-option
                    [value]="option">
                    {{ option.meeting_point_list_description }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        </div>
        <!--end ActualTrip-->

        <!-- Resource -->
        @if (selectedRadio==='Risorsa' || selectedRadio === 'Pacchetto' && selectedSubPackFilter === 'Risorsa') {
          <mat-form-field class="filter-chip-list">
            <mat-chip-grid #chip aria-label="Resource selection">
              @for (tripResource of filterResource; track tripResource) {
                <mat-chip-row
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeResource(tripResource.id)">
                  {{ tripResource.description }}
                  @if (true) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input #ResourceInput
                [placeholder]='"Inserisci risorsa..." | translate'
                (input)="resourceFilteredOptions($event.target.value)"
                [matAutocomplete]="autores"
                [matChipInputFor]="chip"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addResource($event)"
                ngModel name="resource" />
            </mat-chip-grid>
            <mat-autocomplete
              #autores="matAutocomplete"
              (optionSelected)="onSelectResource($event)">
              @for (option of resourceOptions | async; track option) {
                <mat-option
                  [value]="option">
                  {{ option.description }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }

        @if (resourceWithPackage && selectedResource) {
          <div class="risorsa-evidenziata">
            <mat-checkbox
              [disabled]="!selectedResource"
              [matTooltip]='"Visualizza tutti i partecipanti ed evidenzia coloro che hanno selezionato una determinata risorsa" | translate'
              name="isHighlighted"
              [(ngModel)]="isHighlighted">
              {{'RISORSA EVIDENZIATA' | translate}}
            </mat-checkbox>
          </div>
        }
        <!--end Resource-->

        <!-- EntityStaff -->
        @if (selectedRadio==='Accompagnatore') {
          <mat-form-field class="filter-chip-list last-filter" >
            <mat-chip-grid #chipcli aria-label="Client selection">
              @for (tripClient of filterClient; track tripClient) {
                <mat-chip-row
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeClient(tripClient.id)">
                  {{ tripClient.description }}
                  @if (true) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input #clientInput
                [placeholder]='"Inserisci accompagnatore..." | translate'
                (input)="clientFilteredOptions($event.target.value)"
                [matAutocomplete]="autocli"
                [matChipInputFor]="chipcli"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addClient($event)"
                ngModel name="entity" />
            </mat-chip-grid>
            <mat-autocomplete
              #autocli="matAutocomplete"
              (optionSelected)="onSelectClient($event)" >
              @for (option of entityOptions | async; track option) {
                <mat-option
                  [value]="option">
                  {{ option.description }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        <!--end EntityStaff-->

        <!-- EntityCustomer -->
        @if (selectedRadio==='Cliente') {
          <mat-form-field class="filter-chip-list last-filter" >
            <mat-chip-grid #chipcust aria-label="Client selection">
              @for (tripCustomer of filterCustomer; track tripCustomer) {
                <mat-chip-row
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeCustomer(tripCustomer.id)">
                  {{ tripCustomer.description }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              }
              <input #customerInput
                placeholder="Inserisci cliente..."
                (input)="customerFilteredOptions($event.target.value)"
                [matAutocomplete]="autocust"
                [matChipInputFor]="chipcust"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addCustomer($event)"
                ngModel name="customer" />
            </mat-chip-grid>
            <mat-autocomplete
              #autocust="matAutocomplete"
              (optionSelected)="onSelectCustomer($event)" >
              @for (option of customerOptions | async; track option) {
                <mat-option
                  [value]="option">
                  {{ option.entity?.description }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        <!--end EntityCustomer-->

        <!-- MeetingPoint -->
        @if (selectedRadio==='Punto di ritrovo') {
          <mat-form-field class="filter-chip-list last-filter" >
            <mat-chip-grid #chipmp aria-label="Meeting point selection">
              @for (mp of filterMeetingPoints; track mp) {
                <mat-chip-row
                  [selectable]="true"
                  [removable]="true"
                  (removed)="removeMeetingPoint(mp.id)">
                  {{ mp.description }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-row>
              }
              <input #meetingPointInput
                [placeholder]='"Inserisci punto di ritrovo..." | translate'
                (input)="meetingPointFilteredOptions($event.target.value)"
                [matAutocomplete]="automp"
                [matChipInputFor]="chipmp"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addMeetingPoint($event)"
                ngModel name="meeting_point" />
            </mat-chip-grid>
            <mat-autocomplete
              #automp="matAutocomplete"
              (optionSelected)="onSelectMeetingPoint($event)" >
              @for (option of meetingPointOptions | async; track option) {
                <mat-option
                  [value]="option">
                  {{ option.description }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        <!--end MeetingPoint-->

        <mat-card-actions>
          <button [disabled]='!canDownloadList()' mat-flat-button color='accent' (click)="downloadListaPartecipanti()">
            Download
          </button>

          <button style="margin-left: 20px;" [disabled]='!canDownloadList()' mat-flat-button color='warn' (click)="emailListaPartecipanti()">
            {{'Invia mail' | translate}}
          </button>
        </mat-card-actions>
      </mat-card>


      <!--- LISTA CARICHI -->
      <mat-card class='p-24 lista-carichi'>
        <mat-card-header>
          <mat-card-title>{{'Lista Transfert' | translate}}</mat-card-title>
        </mat-card-header>

        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" name="listaCarichiSelezionata" [(ngModel)]="listaCarichiSelezionata">
          @for (radio of listaCarichi; track radio) {
            <mat-radio-button class="example-radio-button" [value]="radio"
              [disabled]="dataValidation.invalid">
              {{radio}}
            </mat-radio-button>
          }
        </mat-radio-group>

        <!--Package-->
        <div class="pacchetto-wrapper">
          @if (listaCarichiSelezionata==='Pacchetto') {
            <mat-form-field class="filter-chip-list" >
              <mat-chip-grid #chipListaCarichi aria-label="Package selection">
                @for (tripPackage of filterPickUpPackages; track tripPackage) {
                  <mat-chip-row
                    [selectable]="true"
                    [removable]="true"
                    (removed)="removePickUpPackage(tripPackage.id)">
                    {{ tripPackage.description }}
                    @if (true) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
                <input #listaCarichiInput
                  [placeholder]='"Seleziona pacchetto..." | translate'
                  (input)="loadPickUpPackages($event.target.value)"
                  [matAutocomplete]="listaCarichiAutocomplete"
                  [matChipInputFor]="chipListaCarichi"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addPickUpPackage($event)"
                  ngModel name="pacchetto_lista_carichi"
                  [required]="listaCarichiSelezionata==='Pacchetto'" />
              </mat-chip-grid>
              <mat-autocomplete
                #listaCarichiAutocomplete="matAutocomplete"
                (optionSelected)="onSelectPickUpPackage($event)">
                @for (option of filteredPickUpPackages | async; track option) {
                  <mat-option
                    [value]="option">
                    {{ option.description }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        </div>
        <!--end Package-->

        <mat-card-actions>
          <button [disabled]='!selectedPickUpPackage' mat-flat-button color='accent' (click)="downloadListaCarichi()">
            Download
          </button>

          <button style="margin-left: 20px;" [disabled]='!selectedPickUpPackage' mat-flat-button color='warn' (click)="emailListaCarichi()">
            {{'Invia mail' | translate}}
          </button>
        </mat-card-actions>
      </mat-card>

    </form>

  </div>

</div>
